<template>
  <div class="card align-items-center">
    <div class="card-body p-0">
      <div class="text-primary font-size-50">
        <span v-if="icon">
          <img
            v-if="icon.split('.').length >= 2"
            :src="
              require(`@/assets/images/${icon}`)
            "
          />
          <i v-else :class="icon"></i>
        </span>
      </div>
    </div>
    <div class="card-body p-0 pb-3 pt-2 text-center">
      <p class="mx-auto text-uppercase m-0 font-weight-medium">
        {{ name }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "category-card",
  props: {
    icon: {
      type: String
    },
    name: {
      type: String
    }
  }       
}
</script>
<style lang="scss" scoped>
.card {
  margin: 0;
}
</style>